import {
	IUnitDetailsDto,
	DropdownDataDto,
	IBaleStorageDto,
	IUnitDetailsAdminDto,
	IUnitDetailsCountryAdminDto,
	IUnitDetailsAdditionalRequirementsDto,
	IUnitDetailsOptimizationAccessDto,
	TemporarySubscriptionStartDto,
} from 'api/api';
import { constants } from './constants';
import actionCreatorFactory from 'typescript-fsa';
import { UnitFavouriteChangeType } from './types';

const actionCreator = actionCreatorFactory('machine-details');

export const GetMachineDetailsAction = actionCreator.async<{ serialNumber: string }, IUnitDetailsDto>(
	constants.GET_MACHINE_DETAILS
);
export const UpdateUnitOwnerGroupAction = actionCreator.async<
	{ unitId: number; ownerGroupId: number },
	IUnitDetailsDto
>(constants.UPDATE_UNIT_OWNER_GROUP);

export const UpsertMachineDetailsAdminAction = actionCreator.async<IUnitDetailsAdminDto, IUnitDetailsAdminDto>(
	constants.UPSERT_MACHINE_DETAILS_ADMIN
);
export const UpsertMachineDetailsCountryAdminAction = actionCreator.async<
	IUnitDetailsCountryAdminDto,
	IUnitDetailsCountryAdminDto
>(constants.UPSERT_MACHINE_DETAILS_COUNTRY_ADMIN);
export const UpsertMachineDetailsServiceTechnicianOrAdminAction = actionCreator.async<
	IUnitDetailsAdditionalRequirementsDto,
	IUnitDetailsAdditionalRequirementsDto
>(constants.UPSERT_MACHINE_DETAILS_SERVICE_TECHNICIAN_OR_ADMIN);
export const UpsertMachineDetailsOptimizationAccessAction = actionCreator.async<
	IUnitDetailsOptimizationAccessDto,
	IUnitDetailsOptimizationAccessDto
>(constants.UPSERT_MACHINE_DETAILS_OPTIMIZATION_ACCESS);

export const GetDropdownOptions = actionCreator.async<{}, DropdownDataDto>(constants.GET_DROPDOWN_OPTIONS);
export const UpdateMachineWeighingSerialNumberAction = actionCreator.async<
	{ unitId: string; weighingSerialNumber?: string },
	void
>(constants.UPDATE_MACHINE_WEIGHING_SERIAL_NUMBER);

// Baler functions
export const UpsertBaleStorageAction = actionCreator.async<IBaleStorageDto, IBaleStorageDto>(
	constants.UPSERT_BALE_STORAGE
);

export const UpdateIsFavouriteAction = actionCreator<UnitFavouriteChangeType>(constants.UPDATE_IS_FAVOURITE);

export const setTemporarySubscription = actionCreator.async<TemporarySubscriptionStartDto, void>(
	constants.SET_TEMPORARY_SUBSCRIPTION
);
